var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50161 0.51001C3.26959 0.51001 0.648865 2.54546 0.648865 5.05239C0.648865 6.61312 1.66334 7.98851 3.20456 8.8079L2.55426 11.1913C2.49573 11.4026 2.73634 11.5717 2.92168 11.4481L5.76676 9.559C6.00738 9.58176 6.25124 9.59477 6.49836 9.59477C9.73037 9.59477 12.3511 7.55931 12.3511 5.05239C12.3511 2.54546 9.73362 0.51001 6.50161 0.51001Z",
    fill: "#191700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKakao);
export default __webpack_public_path__ + "static/media/logo_kakao.d44ebc6983f0f28544e22f443733e7ee.svg";
export { ForwardRef as ReactComponent };